const orderAlphabeticCharacter = (s: string) => s.localeCompare('a');
const orderNumericCharacter = (s: string) => s.localeCompare('0');

export const orderAlphabetically = (s1: string, s2: string) =>
    (orderAlphabeticCharacter(s2) >= 0) - (orderAlphabeticCharacter(s1) >= 0) ||
    (orderNumericCharacter(s2) >= 0) - (orderNumericCharacter(s1) >= 0) ||
    s1.localeCompare(s2);
